<template>
    <div v-if="show" @click="onClick" :class="[enableClick ? 'cursor-pointer' : 'cursor-default']">
        <slot :active="active" />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';

@Component
export default class Slide extends Vue {
    @Inject({
        default: () => null
    }) readonly registerSlide!: Function;

    @Prop() id: string;
    @Prop() title: string;
    @Prop() text: string;
    @Prop() url: string;
    @Prop() target: string;
    @Prop() label: string;
    @Prop() image: string;
    @Prop({ type: Boolean, default: false }) editMode: boolean;
    @Prop({ type: Boolean, default: false }) enableClick: boolean;

    show = true;
    active = false;

    mounted() {
        if (!this.editMode) {
            this.registerSlide(this);
        }
    }

    onClick() {
        if (this.enableClick) {
            this.$emit('click', this);
        }
    }

    get imageUrl(): string {
        if (this.image) {
            return this.image.startsWith(this.$contextPath) ? this.image : `${this.$contextPath}${this.image}`;
        }
        return '';
    }

    get _id(): string {
        return this.id ? this.id : `${this._uid}`;
    }
}

</script>
